<app-snackbar *ngIf="!isRightSliderOpened()"></app-snackbar>
<div class="flex-column gap-M pad-L" style="min-width: 1200px;">
	<div class="flex gap-M header-container w-100">
		<div class="flex-align-center search-bar-container bkg-white b-radius-9">
			<app-text-button type="default" color="primary" class="search-btn" panelClass="h-100-imp pad-0-imp"
							 (click)="openSearchPanel(input)">
				<div class="flex-center">
					<img src="assets/icons/search-md.svg" width="18" height="18" alt=""/>
				</div>
			</app-text-button>
			<div class="flex-space-between">
				<input #input class="search-input" [ngClass]="{'display-input': openSearch}"
					   [formControl]="$any(filterForm.get(form.name))"
					   [placeholder]="openSearch ? ('page.workstation.list.search'|translate) : ''">
				<app-text-button (click)="clearInput()" *ngIf="openSearch && searchValue" type="default"
								 color="primary"
								 panelClass="h-100-imp pad-0-imp" class="delete-text-button mr-xs">
					<div class="flex-center">
						<img src="assets/icons/close.svg" alt="">
					</div>
				</app-text-button>
				<div *ngIf="openSearch && !searchValue" style="width: 35px; height: 30px;">
				</div>
			</div>
		</div>
		<div class="flex-align-center filter-bar bkg-white b-radius-9 w-100">
			<div class="flex-align-center h-100 filter-btn-container" style="z-index: 2;">
				<app-dropdown #filterDropdown>
					<div class="flex-column gap-S" style="width: 300px;"
						 *ngIf="!_loadingFilter && !!list">
						<div class="flex-column gap-S">
							<span class="font-M fw-500 grey">{{'page.application.table.filters.team'|translate}}</span>
							<app-multi-select [inputControl]="$any(filterForm.get(form.organization))" multiple [addMinHeight]="true">
								<app-select-trigger appearance="field">{{!$any(filterForm.get(form.organization)).value[0] ? '-' : ($any(filterForm.get(form.organization)).value[0].name  + ($any(filterForm.get(form.organization)).value.length > 1 ? ' (+' + ($any(filterForm.get(form.organization)).value.length - 1) + ')' : ''))}}</app-select-trigger>
								<app-select-search [searchControl]="$any(filterForm.get(form.searchOrganization))"></app-select-search>
								<app-select-option-group *ngFor="let group of list.organization" [label]="group.organization.name" noOptionPrefix>
									<app-select-option *ngFor="let org of group.children" [value]="org.organization">
										<div class="flex-align-center gap-M">
											<img [src]="!org.organization.icon ? 'assets/icons/team.svg' : ('/assets/icons/team_icon/' + org.organization.icon + '.svg')" class="filter-accent" height="16px">
											<span>{{org.organization.name}}</span>
										</div>
									</app-select-option>
								</app-select-option-group>
							</app-multi-select>
						</div>
						<div class="flex-column gap-S">
							<span class="font-M fw-500 grey">{{'page.application.table.filters.status'|translate}}</span>
							<app-multi-select [inputControl]="$any(filterForm.get(form.status))" multiple>
								<app-select-trigger appearance="field">{{!$any(filterForm.get(form.status)).value[0] ? '-' : ((('page.infrastructure.overview.' + $any(filterForm.get(form.status)).value[0]).toLowerCase()|translate) + ($any(filterForm.get(form.status)).value.length > 1 ? ' (+' + ($any(filterForm.get(form.status)).value.length - 1) + ')' : ''))}}</app-select-trigger>
								<app-select-option *ngFor="let status of list.status" [value]="status">
									<div class="flex-align-center gap-S">
										<div class="workstation-status-bubble"
											 [class.workstation-status-bubble-success]="status === DataCollectionStatus.ACTIVE"
											 [class.workstation-status-bubble-unknown]="status !== DataCollectionStatus.ACTIVE">
										</div>
										<span>{{ 'page.infrastructure.overview.' + status.toLowerCase() | translate }}</span>
									</div>

								</app-select-option>
							</app-multi-select>
						</div>
						<div class="flex-column gap-S">
							<span class="font-M fw-500 grey">{{'page.application.table.health'|translate}}</span>
							<app-multi-select [inputControl]="$any(filterForm.get(form.health))" multiple>
								<app-select-trigger appearance="field">{{!$any(filterForm.get(form.health)).value[0] ? '-' : ((('page.dashboard.typology.' + $any(filterForm.get(form.health)).value[0])|translate) + ($any(filterForm.get(form.health)).value.length > 1 ? ' (+' + ($any(filterForm.get(form.health)).value.length - 1) + ')' : ''))}}</app-select-trigger>
								<app-select-option *ngFor="let health of list.health" [value]="health">
									{{ 'page.dashboard.typology.' + health.toLowerCase() | translate }}
								</app-select-option>
							</app-multi-select>
						</div>
						<div class="flex-column gap-S">
							<span class="font-M fw-500 grey">OS</span>
							<app-multi-select [inputControl]="$any(filterForm.get(form.os))" multiple>
								<app-select-trigger appearance="field">{{!$any(filterForm.get(form.os)).value[0] ? '-' : ($any(filterForm.get(form.os)).value[0]  + ($any(filterForm.get(form.os)).value.length > 1 ? ' (+' + ($any(filterForm.get(form.os)).value.length - 1) + ')' : ''))}}</app-select-trigger>
								<app-select-option *ngFor="let os of list.os" [value]="os">
									{{ os }}
								</app-select-option>
							</app-multi-select>
						</div>
					</div>
					<div class="flex w-100" style="margin: 20px -20px -20px -20px; width: calc(100% + 40px);">
						<app-text-button color="primary" class="w-100" panelClass="bkg-light-grey-2-imp b-radius-bottom-9"
										 (click)="clearFilters(); filterDropdown.close();">
							<div class="flex-align-center gap-S" style="margin-left: -15px;">
								<img src="assets/icons/close.svg" width="12" height="12" alt=""/>
								<span>{{'page.application.table.filters.clear'|translate}}</span>
							</div>
						</app-text-button>
					</div>
				</app-dropdown>
				<app-text-button type="default" color="primary" class=filter-btn panelClass="h-100-imp"
								 [badge]="activeFilters.length > 0 ? activeFilters.length : undefined"
								 [disabled]="!list" [loading]="_loadingFilter"
								 [dropdownTrigger]="filterDropdown">
					<div class="flex-center gap-S">
						<span>{{'page.application.table.filters.button'|translate}}</span>
						<img src="assets/icons/filter-lines.svg" width="16" height="16" alt=""/>
					</div>
				</app-text-button>
			</div>
			<div class="flex-align-center w-100 h-100 border-light-grey-left pad-left-S filter-panel" style="z-index: 1; transition: 0s;" #responsiveFilterPanel
				 [ngClass]="{'filter-panel-open': openFilters}" [style.top.px]="(responsiveFilterPanel.offsetHeight / 2) - 26.5" >
				<div class="flex-wrap flex-align-center h-100 gap-S" style="width: calc(100% - 30px); margin: 12px 0;"
					 [ngStyle]="{'max-height': openFilters ? '100%' : '28px'}" [ngClass]="{'overflow-hidden': !openFilters}">
					@for (filter of activeFilters; track filter.id) {
						<div class="flex-center horizontal-bar-L bkg-light-grey-2 pad-0-M gap-M">
							<span class="font-S fw-500">{{filter.value}}</span>
							<img class="filter-grey c-p" src="assets/icons/close.svg" width="9" height="9" alt="" style="z-index: 9999"
								 (click)="removeFilter(filter)"/>
						</div>
					}
				</div>
				<div class="flex-center b-radius-right-9 c-p" style="width: 30px; height: 30px;"
					 (click)="openFilters = !openFilters" *ngIf="activeFilters.length">
					<img src="assets/icons/arrow-right-black.svg" class="rotate-90 filter-grey" height="12" alt="">
				</div>
			</div>
		</div>
		<div class="flex-align-center filter-bar bkg-white b-radius-9" style="padding: 3px;">
			<app-text-button type="default" color="primary" style="width: 43px; height: 43px;"
							 panelClass="h-100-imp pad-0-imp"
							 (click)="refresh()"
							 [disabled]="_loading"
							 [loading]="_refreshing">
				<div class="flex-center">
					<img src="assets/icons/refresh-cw-01.svg" height="18" alt=""/>
				</div>
			</app-text-button>
		</div>
		<div class="flex-align-center filter-bar bkg-white b-radius-9" style="padding: 3px;">
			<app-text-button type="default" color="primary" style="width: 43px; height: 43px;"
							 panelClass="h-100-imp pad-0-imp"
							 [matMenuTriggerFor]="selectMenu" [disabled]="_loading"
							 [loading]="_exporting">
				<div class="flex-center">
					<img src="assets/icons/dots-vertical.svg" height="18" alt=""/>
				</div>
			</app-text-button>
			<mat-menu #selectMenu class="mat-menu-custom"
					  xPosition="before" yPosition="below">
				<div class="flex-align-center gap-M greyed-hover b-radius-6 c-p" style="padding: 6px;"
					 (click)="exportCsv()">
					<img src="assets/icons/share.svg" width="18" height="18" alt=""/>
					<div class="font-M fw-500">{{ 'page.application.table.filters.export'|translate }}</div>
				</div>
				<div class="flex-align-center gap-M greyed-hover b-radius-6 c-p" style="padding: 6px;"
					 (click)="exportXlsx()">
					<img src="assets/icons/layout-grid-02.svg" width="18" height="18" alt=""/>
					<div class="font-M fw-500">{{ 'page.application.table.filters.exportX'|translate }}</div>
				</div>
			</mat-menu>
		</div>
	</div>
	<div *ngIf="!_loading && !_refreshing"
		 class="flex-column app-list-content bkg-white">
		<table class="app-list-table" aria-describedby="apps"
			   [style.height]="workstationFilteredRows.length <= 0 ? 'calc(100vh - 190px)' : ''"
			   [style.min-height]="workstationFilteredRows.length <= 0 ? '350px' : ''">
			<tr class="app-list-header">
				<th>
					<div class="flex-align-center gap-S pad-0-S greyed-hover sort-column c-p"
						 style="border-top-left-radius: 14px; padding-left: 67px;"
						 [ngClass]="{'sort-active': sortFormValue.column === column.NAME}"
						 (click)="sortBy(column.NAME)">
						<span
							class="font-M fw-500 text-left grey">{{ 'page.workstation.list.name' | translate }}</span>
						<img src="assets/icons/arrow-right-black.svg" class="filter-grey" height="10"
							 alt=""
							 [ngStyle]="{'transform': 'rotate(' + (sortFormValue.direction === direction.DESC && sortFormValue.column === column.NAME ? '90' : '-90') + 'deg)'}">
					</div>
				</th>
				<th>
					<div class="flex-align-center gap-S pad-0-S greyed-hover sort-column c-p"
						 [ngClass]="{'sort-active': sortFormValue.column === column.HEALTH}"
						 (click)="!_loading ? sortBy(column.HEALTH) : {}">
						<span class="font-M fw-500 text-left grey">{{'page.application.table.health'|translate}}</span>
						<img src="assets/icons/arrow-right-black.svg" class="filter-grey" height="10" alt=""
							 [ngStyle]="{'transform': 'rotate(' + (sortFormValue.direction === direction.DESC && sortFormValue.column === column.HEALTH ? '90' : '-90') + 'deg)'}">
					</div>
				</th>
				<th>
					<div class="flex-align-center gap-S pad-0-S greyed-hover sort-column c-p"
						 [ngClass]="{'sort-active': sortFormValue.column === column.USER}"
						 (click)="sortBy(column.USER)">
						<span
							class="font-M fw-500 text-left grey">{{ 'page.workstation.list.user' | translate }}</span>
						<img src="assets/icons/arrow-right-black.svg" class="filter-grey" height="10"
							 alt=""
							 [ngStyle]="{'transform': 'rotate(' + (sortFormValue.direction === direction.DESC && sortFormValue.column === column.USER ? '90' : '-90') + 'deg)'}">
					</div>
				</th>
				<th>
					<div class="flex-align-center gap-S pad-0-S greyed-hover sort-column c-p"
						 [ngClass]="{'sort-active': sortFormValue.column === column.IP_ADDRESS}"
						 (click)="sortBy(column.IP_ADDRESS)">
						<span
							class="font-M fw-500 text-left grey">{{ 'page.workstation.list.ipAddress' | translate }}</span>
						<img src="assets/icons/arrow-right-black.svg" class="filter-grey" height="10"
							 alt=""
							 [ngStyle]="{'transform': 'rotate(' + (sortFormValue.direction === direction.DESC && sortFormValue.column === column.IP_ADDRESS ? '90' : '-90') + 'deg)'}">
					</div>
				</th>
				<th>
					<div class="flex-align-center gap-S pad-0-S greyed-hover sort-column c-p"
						 [ngClass]="{'sort-active': sortFormValue.column === column.LOAD}"
						 (click)="sortBy(column.LOAD)">
						<span
							class="font-M fw-500 text-left grey">{{ 'page.workstation.list.load' | translate }}</span>
						<img src="assets/icons/arrow-right-black.svg" class="filter-grey" height="10"
							 alt=""
							 [ngStyle]="{'transform': 'rotate(' + (sortFormValue.direction === direction.DESC && sortFormValue.column === column.LOAD ? '90' : '-90') + 'deg)'}">
					</div>
				</th>
				<th>
					<div class="flex-align-center gap-S pad-0-S greyed-hover sort-column c-p"
						 [ngClass]="{'sort-active': sortFormValue.column === column.STORAGE}"
						 (click)="sortBy(column.STORAGE)">
						<span
							class="font-M fw-500 text-left grey">{{ 'page.workstation.list.storage' | translate }}</span>
						<img src="assets/icons/arrow-right-black.svg" class="filter-grey" height="10"
							 alt=""
							 [ngStyle]="{'transform': 'rotate(' + (sortFormValue.direction === direction.DESC && sortFormValue.column === column.STORAGE ? '90' : '-90') + 'deg)'}">
					</div>
				</th>
			</tr>
			@if (workstationRows.length > 0) {
				@for (workstation of workstationFilteredRows; track workstation.id) {
					<tr class="app-list-row font-M fw-500 greyed-hover c-p"
						(click)="openWorkstationRow(workstation.id)">
						<td style="width: 16.66%">
							<div class="flex gap-M" style="padding-left: 3px;">
								<div class="workstation-icon flex-center p-relative" tooltipPosition="right" [tooltipOffset]="5" [tooltip]="getDataCollectionStatusTooltip(workstation.collectStatus!!, workstation.lastCollectDate)">
									<img *ngIf="!workstation.laptop" width="22" class="filter-accent" src="assets/icons/monitor-01.svg">
									<img *ngIf="workstation.laptop" width="22" class="filter-accent" src="assets/icons/laptop-02.svg">
									<div class="p-absolute workstation-status-bg flex-center">
										<div class="workstation-status-bubble" [class.workstation-status-bubble-success]="workstation.collectStatus === DataCollectionStatus.ACTIVE" [class.workstation-status-bubble-unknown]="workstation.collectStatus !== DataCollectionStatus.ACTIVE"></div>
									</div>
								</div>
								<div class="flex-column justify-center gap-XS" style="max-width: 300px;">
									<span class="fw-700 font-M text-overflow-ellipsis">
										{{ workstation.hostname }}
									</span>
									<span class="font-S text-overflow-ellipsis">
										{{ workstation.osModel + ' ' + workstation.osVersion }}
									</span>
								</div>
							</div>
						</td>
						<td style="width: 16.66%">
							<div class="flex">
								<app-chips-health [health]="{ percent: 100, status: workstation.health, queryType: QueryRangeType.PAST_1_MONTH }"></app-chips-health>
							</div>
						</td>
						<td style="width: 16.66%">
							<div class="chip-user flex-align-center gap-XS w-fit-content" style="padding-left: 10px; padding-right: 10px;">
								<img src="assets/icons/user-circle.svg" class="filter-primary" height="14px" alt="">
								<span class="text-overflow-ellipsis" style="max-width: 150px;">{{ workstation.userRealName || '-' }}</span>

							</div>
						</td>
						<td style="width: 16.66%">
							<span>{{ workstation.privateIp || '-' }}</span>
						</td>
						<td style="width: 16.66%">
							<div>
								<div class="primary fw-700 mb-xs">{{ workstation.load }}%</div>
								<div class="progress-bar not-empty w-50">
									<div class="bar bar-normal" [ngStyle]="{width: workstation.load + '%'}"></div>
								</div>
							</div>
						</td>
						<td style="width: 16.66%">
							<div class="flex-space-between pad-right-S">
								<div>
									<div class="primary fw-700 mb-xs">{{ workstation.storageLoad ? (workstation.storageLoad | number: '1.0-0') + '%' : '-' }}</div>
									<div class="progress-bar not-empty" style="width: 129px;">
										<div class="bar bar-normal" [style.width.%]="workstation.storageLoad || 0"></div>
									</div>
								</div>
								<img src="assets/icons/arrow-right.svg" width="9" alt=""/>
							</div>
						</td>
					</tr>
				} @empty {
					<tr>
						<td colspan="6">
							<div class="flex-center flex-column gap-XL">
								<img src="assets/illustrations/empty-app.svg">
								<span class="grey">{{ 'page.workstation.list.noWorkstationSearch' | translate }}</span>
							</div>
						</td>
					</tr>
				}
			} @else {
				<tr>
					<td colspan="6">
						<div class="flex-center flex-column gap-XL">
							<img src="assets/illustrations/no-server-network.svg">
							<div class="flex-column gap-S flex-center">
								<span class="grey">{{ 'page.workstation.list.noWorkstationConfiguredInKabeen1' | translate }}</span>
								<span class="grey">{{ 'page.workstation.list.noWorkstationConfiguredInKabeen2' | translate }}</span>
							</div>
							<app-text-button *ngIf="isEditor" type="flat" color="accent" (click)="deployMyAgents()">
								{{ 'page.workstation.list.deployMyAgents' | translate }}
							</app-text-button>
						</div>
					</td>
				</tr>
			}
		</table>
		<div *ngIf="workstationFilteredRows.length > 0" class="app-list-footer bkg-white">
			<div class="font-M fw-500 pad-M grey">
				Total {{ workstationFilteredRows.length }} {{ 'page.workstation.list.workstations' | translate }}
			</div>
		</div>
	</div>
	<div *ngIf="_loading || _refreshing" class="flex-justify-center flex-align-center flex-column gap-20"
		 style="height: calc(100vh - 250px)">
		<app-spinner color="grey" [scale]="0.8"></app-spinner>
	</div>
</div>
